import { render } from "./PembayaranPbb.vue?vue&type=template&id=4a9d4a0c"
import script from "./PembayaranPbb.vue?vue&type=script&lang=js"
export * from "./PembayaranPbb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__